import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import PaginationBar from './components/PaginationBar';
import DefaultModal from './components/modals/DefaultModal';
import ParametroEntidadeModal from './components/modals/ParametroEntidadeModal';
import useDefaultModal from './components/hooks/useDefaultModal';
import usePagination10 from './components/hooks/usePagination10';

function ParametrosEntidade() {
  const [list, setList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'nome', direction: 'asc' });

  const normalizeString = str => {
    if (!str) return '';
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  };

  const sortedList = [...list].sort((a, b) => {
    const dir = sortConfig.direction === 'asc' ? 1 : -1;
    return String(a[sortConfig.key]).localeCompare(String(b[sortConfig.key]), 'pt-BR', { numeric: true }) * dir;
  });

  const filteredList = sortedList.filter(row => {
    const termo = normalizeString(filtro);
    return (
      normalizeString(row.cnpj).includes(termo) ||
      normalizeString(row.nome).includes(termo)
    );
  });

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const { setPagination } = usePagination10(filteredList.length);

  const paginatedList = filteredList.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const load = () => {
    if (!token) {
      navigate('/');
      return;
    }
    setLoading(true);
    axios.get(`${API_BASE_URL.ENTIDADE}/all`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(result => setList(result.data))
      .catch(() => showDefaultModal('error', 'Erro ao carregar entidades.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortIcon = (key) => {
    if (sortConfig.key !== key) return <i className="bi bi-arrow-down-up ms-1" style={{ opacity: 0.3 }} />;
    return sortConfig.direction === 'asc'
      ? <i className="bi bi-sort-up ms-1" />
      : <i className="bi bi-sort-down ms-1" />;
  };

  useEffect(() => {
    setPagination.onFirstItems();
  }, [filtro]);

  const handleParametros = () => {
    if (!selectedRow) return;
    setShowModal(true);
  };

  const handleRowClick = (row) => {
    setSelectedRow(prev => prev?.cnpj === row.cnpj ? null : row);
  };

  const handleSaved = () => { setShowModal(false); load(); };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Parâmetros por Entidade" icon="bi-sliders" />
        <PageContent>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between gap-2 mb-2 align-items-start align-items-lg-center">
            <div className="botao-grid-2col">
              <button className="btn btn-primary btn-sm botao-igual" onClick={handleParametros} disabled={!selectedRow}>
                <i className="bi bi-gear me-1" /> Parâmetros
              </button>
            </div>
            <div className="input-group input-group-sm mt-2 mt-lg-0" style={{ maxWidth: '300px' }}>
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Buscar por CNPJ ou nome"
                value={filtro}
                onChange={e => setFiltro(e.target.value.toUpperCase())}
              />
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
            <DataTable style={{ fontSize: '0.8rem' }} head={
              <tr>
                <th style={{ width: '150px', cursor: 'pointer' }} onClick={() => handleSort('cnpj')}>
                  CNPJ {sortIcon('cnpj')}
                </th>
                <th style={{ cursor: 'pointer' }} onClick={() => handleSort('nome')}>
                  Nome {sortIcon('nome')}
                </th>
              </tr>}>
              <tbody>
                {paginatedList && paginatedList.length > 0 ? paginatedList.map((row) => (
                  <tr
                    key={row.cnpj}
                    onClick={() => handleRowClick(row)}
                    className={selectedRow?.cnpj === row.cnpj ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{row.cnpj}</td>
                    <td>{row.nome}</td>
                  </tr>
                )) : (
                  <tr><td colSpan={2} className="text-center">Nenhuma entidade encontrada.</td></tr>
                )}
              </tbody>
            </DataTable>
          </TableContainer>
        </PageContent>
        <PaginationBar setPagination={setPagination} />
      </ResponsiveShadow>

      <ParametroEntidadeModal show={showModal} onClose={() => setShowModal(false)} onSave={handleSaved} data={selectedRow} />
      <DefaultModal {...setDefaultModal} />
    </Layout>
  );
}

export default ParametrosEntidade;
